export default (cb, apiIndex = 0) => {
  const mapKeys = [
    process.env.VUE_APP_YANDEX_API_KEY_7,
    process.env.VUE_APP_YANDEX_API_KEY_8,
    process.env.VUE_APP_YANDEX_API_KEY_9,
    process.env.VUE_APP_YANDEX_API_KEY_10,
    process.env.VUE_APP_YANDEX_API_KEY_11,
    process.env.VUE_APP_YANDEX_API_KEY_12,
    process.env.VUE_APP_YANDEX_API_KEY_1,
    process.env.VUE_APP_YANDEX_API_KEY_2,
    process.env.VUE_APP_YANDEX_API_KEY_3,
    process.env.VUE_APP_YANDEX_API_KEY_4,
    process.env.VUE_APP_YANDEX_API_KEY_5,
    process.env.VUE_APP_YANDEX_API_KEY_6
]

  let apiIndexLocal = apiIndex

  const addMapScript = key => {
    const id = 'yandex-map'
    const url = 'https://api-maps.yandex.ru/2.1/?apikey=' + key + '&lang=ru_RU'
    const scriptMapOld = document.getElementById(id)
    if (scriptMapOld) {
      scriptMapOld.remove()
    }
    const scriptMap = document.createElement( 'script' )

    scriptMap.onload = () => {
      window.ymaps.ready(() => {
        cb(apiIndexLocal)
      })
    }

    scriptMap.onerror = () => {
      apiIndexLocal += 1
      if (mapKeys[apiIndexLocal]) {
        addMapScript(mapKeys[apiIndexLocal])
      }
    }

    scriptMap.src = url
    scriptMap.id = id

    document.body.appendChild(scriptMap)
  }
  if (mapKeys[apiIndexLocal]) {
    addMapScript(mapKeys[apiIndexLocal])
  }
}